module.exports = __webpack_public_path__ + "img/favicons/evi/favicon-32x32.png";